import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

@Component({
  selector: 'step-property-type',
  templateUrl: '../../step/button-step/button-step.component.html',
  styleUrls: ['./property-type.component.scss', '../../step/step.component.scss','../../step/button-step/button-step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class PropertyTypeComponent extends ButtonStepComponent implements OnInit {
  noBrandTitle = "Get Home Purchase Rates & Options from Multiple Lenders";
  title = "Type of home";
  buttonList = [
    { text: 'Single Family', value: 'Single', imageName: 'single-family', default: true },
    { text: 'Multi Family', value: 'Multi', imageName: 'multi-family' },
    { text: 'Condo', value: 'Condo', imageName: 'condo' },
    { text: 'Town House', value: 'Town House', imageName: 'town-house' },
    { text: 'Cooperative', value: 'Cooperative', imageName: 'cooperative' },
    { text: 'Manufactured or Mobile', value: 'Mobile', imageName: 'manufactured' },
  ];

  ngOnInit() {
    const name = 'propertyType';
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl(name, this.control);
    this.analyticsService.trackQuestionShown(name);
  }
  
}
